import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { AppInsightsContext, AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { Config } from './config';


export type LogFN = (message?: any, ...optionalParams: any[]) => void;

export type LogConfig = {
    log?: LogFN;
    logError?: LogFN;
    logWarning?: LogFN;
    logInfo?: LogFN;
}

var reactPlugin = new ReactPlugin();
var clickPlugin = new ClickAnalyticsPlugin();
var clickPluginConfig = {
    autoCapture: true
};

var tagsEnvironment = Config.Environment;
var tagsRole = Config.Role;
var tagsAppName = Config.AppName;
var tagsAppId = Config.AppId;

export enum LogLevel {
    Verbose = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Critical = 4
}

class GLAppInsights extends ApplicationInsights {

    public constructor(config: any) {
        super(config);
        if (config.loggingLevelConsole === undefined) {
            config.loggingLevelConsole = LogLevel.Verbose;
        }
    }

    public set LogLevel(value: number) {
        this.config.loggingLevelConsole = value;
    }

    public fireUserLoggedIn(userId: string, logFN?: LogFN) {
        this.trackEvent({ name: 'UserLoggedIn', properties: { userId: userId } });
        logFN?.(`UserLoggedIn: ${userId}`);
    }

    public fireUserLoggedOut(userId: string, logFN?: LogFN) {
        this.trackEvent({ name: 'UserLoggedOut', properties: { userId: userId } });
        logFN?.(`UserLoggedOut: ${userId}`);
    }

    public fireAppLaunch(logFN?: LogFN) {
        this.trackEvent({ name: 'AppLaunch' });
        logFN?.(`AppLaunch`);
    }
}

export const appInsights = new GLAppInsights({
    config: {
        connectionString: 'InstrumentationKey=0c039c92-39eb-438b-b696-bae5a9c91fc6;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=ace11939-10a1-4479-b160-3c471ec1e7b9',
        extensions: [reactPlugin, clickPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: {},
            [clickPlugin.identifier]: clickPluginConfig
            // *** Add the Click Analytics plug-in. ***
            // [clickPluginInstance.identifier]: clickPluginConfig
        },
        autoTrackPageVisitTime: true,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableAjaxTracking: false,
    }
});
appInsights.loadAppInsights();



appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
    env.tags = env.tags || [];
    env.tags["ai.cloud.role"] = tagsRole;
    //custom props
    env.data = env.data || {};
    env.data["enviroment"] = tagsEnvironment;
    env.data["appId"] = tagsAppId;
    env.data["ms-appName"] = tagsAppName;
    env.data["appVersion"] = Config.AppVersion;
});










export function WithAppInsights(props: { children: React.ReactNode }) {

    return (
        <AppInsightsErrorBoundary onError={() => <h1>I believe something went wrong</h1>} appInsights={reactPlugin}>
            <AppInsightsContext.Provider value={reactPlugin}>
                {props.children}
            </AppInsightsContext.Provider>
        </AppInsightsErrorBoundary>
    );
}